import { ErrorBoundary } from "@xemplo/error-boundary";
import { Route, Routes } from "react-router-dom";
import {
  Features,
  PublicRoutes,
  RoutesWithSidebar,
  RoutesWithoutSidebar,
  RoutesWithoutSidebarAndNavbar,
} from "../constants";

import {
  PayrunV2Routes,
  V2AmendmentsScreenRoute,
  V2DashboardRoute,
  V2RoutesWithTemplate,
  V2UsersScreenRoute,
  V2PayScheduleRoutes,
  V2PayScheduleRouteWithTemplate,
} from "../constants/routes/v2-routes";

import { useAppInit } from "../hooks/useAppInit";
import TemplateNoSidebarAndNavbar from "../Layout/TemplateNoSidebarAndNavbar";
import TemplateWithSidebar from "../Layout/TemplateSidebar";
import { V2FeatureRoute } from "./V2FeatureRoute";
import { V2FeatureTemplate } from "../Layout/V2FeatureTemplate";
import { AuthorisationRoutes } from "@xemplo/authorisation-router";
import { PersonaRole } from "@xemplo/gp-types";

export const RouteInit = () => {
  useAppInit();

  // Should probably add all routes that requires authentication, and split the routes that requires claims
  // then we can iterate through them and wrap the element with the RequireAuth and RequireSecureComponent
  return (
    <Routes>
      {/* Fullscreen routes (no layout template)*/}
      {[...PublicRoutes, ...RoutesWithoutSidebar].map((data) => {
        return (
          <Route
            key={data.path}
            path={data.path}
            element={data.element}
            errorElement={<ErrorBoundary />}
          />
        );
      })}
      {AuthorisationRoutes.map((data) => {
        return (
          <Route
            key={data.path}
            path={data.path}
            Component={data.Component}
            errorElement={<ErrorBoundary />}
          />
        );
      })}

      {/** V2 Fullscreen Page routes */}
      {/* /payrun/:id */}
      {V2FeatureRoute(PayrunV2Routes, undefined, [
        PersonaRole.CompanyAdmin,
        PersonaRole.CompanyAccountant,
      ])}

      {/* /payschedule/:id */}
      {V2FeatureRoute(V2PayScheduleRoutes, undefined, [
        PersonaRole.PayrollManager,
        PersonaRole.PSPAdmin,
        PersonaRole.SystemAdmin,
      ])}

      {/** V2 Page routes(template includes sidebar and global nav) */}
      <Route element={<V2FeatureTemplate />}>
        {/* /payrun  */}
        {V2FeatureRoute(V2RoutesWithTemplate, undefined, [
          PersonaRole.CompanyAdmin,
          PersonaRole.CompanyAccountant,
          PersonaRole.PSPAdmin,
          PersonaRole.PayrollManager,
          PersonaRole.SystemAdmin,
        ])}
        {/* /home (dashboard) */}
        {V2FeatureRoute(V2DashboardRoute, undefined)}
        {/* /amendments */}
        {V2FeatureRoute(V2AmendmentsScreenRoute, undefined, [
          PersonaRole.CompanyAdmin,
        ])}

        {/* /pay schedules */}
        {V2FeatureRoute(V2PayScheduleRouteWithTemplate, undefined, [
          PersonaRole.PayrollManager,
          PersonaRole.PSPAdmin,
          PersonaRole.SystemAdmin,
        ])}

        {/* /users */}
        {/* Note: will ignore the feature check if this field is passed as undefined */}
        {/* Once all the routes has been updated, we can remove this field */}
        {V2FeatureRoute(V2UsersScreenRoute, undefined, [
          PersonaRole.CompanyAdmin,
          PersonaRole.CompanyAccountant,
          PersonaRole.PSPAdmin,
          PersonaRole.PayrollManager,
          PersonaRole.SystemAdmin,
        ])}

        {/* Xemplo Pay - TEST ROUTE - Feature is enabled in DEV only*/}
        {/* TODO: Replace with router lib from expedo-fe*/}
        {V2FeatureRoute(
          [
            {
              path: "payrun/xemplo-pay/:id",
              Component: () => <div>Xemplo Payrun Manager</div>,
            },
          ],
          Features.XemploPay,
          [
            PersonaRole.PayrollManager,
            PersonaRole.PSPAdmin,
            PersonaRole.SystemAdmin,
          ],
        )}
      </Route>

      {/** Routes with Sidebar, global nav, and header layout */}
      <Route element={<TemplateWithSidebar />}>
        {RoutesWithSidebar.map((data) => {
          return (
            <Route
              key={data.path}
              path={data.path}
              element={data.element}
              errorElement={<ErrorBoundary />}
            />
          );
        })}
      </Route>
      {/** Verify Details Route */}
      <Route element={<TemplateNoSidebarAndNavbar />}>
        {RoutesWithoutSidebarAndNavbar.map((data) => {
          return (
            <Route
              key={data.path}
              path={data.path}
              element={data.element}
              errorElement={<ErrorBoundary />}
            />
          );
        })}
      </Route>
    </Routes>
  );
};
